import { render, staticRenderFns } from "./prdDetail.vue?vue&type=template&id=8009aac2&scoped=true&"
import script from "./prdDetail.vue?vue&type=script&lang=js&"
export * from "./prdDetail.vue?vue&type=script&lang=js&"
import style0 from "./prdDetail.vue?vue&type=style&index=0&id=8009aac2&lang=stylus&scoped=true&"
import style1 from "./prdDetail.vue?vue&type=style&index=1&id=8009aac2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8009aac2",
  null
  
)

export default component.exports